(($) => {
    const tab = $('.productPage__tab');
    const tabContent = $('.productPage__tab-pane');

    tab.click(function() {
        const clickedTab = $(this);
        const activeTabContent = tabContent.filter('.active');
        const clickedTabContent = tabContent.filter(`[data-tab="${clickedTab.data('tab')}"]`);

        if (clickedTab.hasClass('active')) {
            if ($(window).width() < 768) {
                clickedTab.removeClass('active sticky');
                clickedTabContent.fadeOut(150);
                clickedTabContent.removeClass('active');
            }
            return;
        }

        if ($(window).width() > 768) {
            activeTabContent.fadeOut(150, function() {
                tab.removeClass('active');
                clickedTab.addClass('active');
                activeTabContent.removeClass('active sticky');
                clickedTabContent.fadeIn(150, function() {
                    clickedTabContent.addClass('active');
                });
            });
        } else {
            clickedTab.addClass('active');
            clickedTabContent.fadeIn(150, function() {
                clickedTabContent.addClass('active');
            });
        }

    });
})(jQuery);
